import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'found';
import { Grid, Loader } from 'semantic-ui-react';
import EventCard from '../../Event/List/EventCard';
import Waypoint from 'react-waypoint';

const SearchResultsComponent = class SearchResults extends React.Component {
  static propTypes = {
    viewer: PropTypes.object,
    location: PropTypes.object,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      listSize: 10,
      loading: false
    };
    this.loadMore = this.loadMore.bind(this);
  }

  loadMore() {
    if (this.props.relay.hasMore() && !this.state.loading) {
      this.props.relay.loadMore(10, () => {
        this.setState({ loading: false, listSize: this.state.listSize + 10 });
      });
      this.setState({ loading: true });
    }
  }

  render() {
    const timeZone = this.props.viewer.s_time_zone;
    const events = this.props.viewer.user_event_search.edges;
    const { query } = this.props.location;
    const { q } = query;

    return (
      <Grid.Row>
        <Grid.Column>
          {events.map((userEvent, idx) =>
            <EventCard
              showDateLabel={false}
              event={userEvent.node}
              timeZone={timeZone}
              key={idx}
              index={idx}
              basic
              link
              location={this.props.location}
              listSize={this.state.listSize}
              relay={this.props.relay}
            />
          )}
          <div style={{ textAlign: 'center', padding: '2em' }}>
            {events.length === 0 && q &&
              <div>
                <h2>We couldn't find anything matching your search.</h2>
              </div>}
            <Waypoint onEnter={this.loadMore} bottomOffset={-50} />
            {this.props.relay.hasMore() &&
              this.state.loading &&
              <div style={{ marginBottom: '2em' }}>
                <Loader
                  active
                  inline
                  size='tiny'
                  style={{ marginRight: '1em' }}
                />{' '}
                Loading More...
              </div>
            }
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }
};

export default withRouter(SearchResultsComponent);



// WEBPACK FOOTER //
// ./webpack/components/App/Search/SearchResults.js